import { render } from "./CouponShowComponent.vue?vue&type=template&id=c376d746"
import script from "./CouponShowComponent.vue?vue&type=script&lang=js"
export * from "./CouponShowComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/coupons/CouponShowComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c376d746"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c376d746', __exports__)) {
    api.reload('c376d746', __exports__)
  }
  
  module.hot.accept("./CouponShowComponent.vue?vue&type=template&id=c376d746", () => {
    api.rerender('c376d746', render)
  })

}


export default __exports__